// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root{--spacing-xxs: 2px;--spacing-xs: 4px;--spacing-s: 8px;--spacing-m: 12px;--spacing-l: 16px;--spacing-xl: 24px;--spacing-xxl: 32px;--spacing-xxl-2: 40px;--spacing-xxl-3: 48px;--spacing-xxl-4: 56px;--spacing-xxl-5: 64px;--spacing-xxl-6: 80px}.b2b-lib-feedback_status{padding:0 var(--spacing-xl)}.b2b-lib-feedback_status_heading{font-size:24px;font-weight:600;margin:0 0 var(--spacing-l) 0;line-height:1.2}.b2b-lib-feedback_status_content{color:#555a5a;font-size:16px;font-weight:600;line-height:1.2;max-height:380px;overflow:auto;min-height:80px}\n", ""]);
// Exports
exports.locals = {
	"feedback_status": "b2b-lib-feedback_status",
	"feedback_status_heading": "b2b-lib-feedback_status_heading",
	"feedback_status_content": "b2b-lib-feedback_status_content"
};
module.exports = exports;
